import React from 'react';
import { ErrorBoundary } from "react-error-boundary";
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import FallbackComponent from '../../../public/components/Shared/ErrorBoundary/Fallback';
import configureStore from '../../../public/store/configureStore';
import { Main } from '../../app';
import { Logger } from '../../app/services';

class ConversationsErrorBoundary extends ErrorBoundary {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public componentDidCatch(error: any, info: any) {
    const renderingError = new Error(error.message);
    renderingError.name = `ReactRenderingError`;
    renderingError.stack = info.componentStack;

    Logger.error(renderingError);
  }
}
  
// eslint-disable-next-line @typescript-eslint/ban-types
const store = (configureStore as unknown as Function)();

export const App = (
  <ConversationsErrorBoundary FallbackComponent={FallbackComponent}>
    <Provider store={store}>
      <BrowserRouter>
        <Main />
      </BrowserRouter>
    </Provider>
  </ConversationsErrorBoundary>
);
